/* Start isotope */

jQuery(document).ready(function($){
  $(".iso-container").isotope({

    itemSelector: '.iso-item',
    masonry: {
      columnWidth: 280,
      gutter: 20,
      isFitWidth: true
    }

  });


  $('ul.filter li').click(function(){ 

    $("ul.filter li").removeClass("active");
    $(this).addClass("active");        

    var selector = $(this).attr('data-filter'); 
    $(".iso-container").isotope({ 
      filter: selector, 
      animationOptions: { 
        duration: 750, 
        easing: 'linear', 
        queue: false, 
      } 
    }); 
    return false; 
  }); 


});

